import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class VersioncheckService {
  private versionUrl = `/assets/version/version.json?v=${new Date().getTime()}`; // Prevent caching
  private checkInterval = 3 * 60 * 1000;

  constructor(private http: HttpClient) { }

  checkForUpdate() {
    this.http.get<{ version: string }>(this.versionUrl).subscribe(
      (data) => {
        const currentVersion = localStorage.getItem('av');
        const newVersion = data.version;

        if (currentVersion && newVersion !== currentVersion) {
          console.log(`🚀 New version detected: ${newVersion}. Reloading...`);
          this.forceReload(newVersion);
        } else {
          localStorage.setItem('av', newVersion);
        }
      },
      (error) => {
        console.error('⚠️ Error checking app version:', error);
      }
    );
  }

  private forceReload(newVersion: string) {
    localStorage.setItem('fr', 'true');
    localStorage.setItem('av', newVersion);
    window.location.reload();
  }

  startVersionCheck() {
    this.checkForUpdate(); // Initial check
    setInterval(() => this.checkForUpdate(), this.checkInterval);
  }
}
